'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const tslib = require('tslib');
const MotionConfigContext = require('../../context/MotionConfigContext.js');
const useConstant = require('../../utils/use-constant.js');
const VisualElementDragControls = require('./VisualElementDragControls.js');

/**
 * A hook that allows an element to be dragged.
 *
 * @internal
 */
function useDrag(props, visualElement) {
  var groupDragControls = props.dragControls;
  var transformPagePoint = React.useContext(MotionConfigContext.MotionConfigContext).transformPagePoint;
  var dragControls = useConstant.useConstant(function () {
    return new VisualElementDragControls.VisualElementDragControls({
      visualElement: visualElement
    });
  });
  dragControls.setProps(tslib.__assign(tslib.__assign({}, props), {
    transformPagePoint: transformPagePoint
  }));
  // If we've been provided a DragControls for manual control over the drag gesture,
  // subscribe this component to it on mount.
  React.useEffect(function () {
    return groupDragControls && groupDragControls.subscribe(dragControls);
  }, [dragControls]);
  // Mount the drag controls with the visualElement
  React.useEffect(function () {
    return dragControls.mount(visualElement);
  }, []);
}

exports.useDrag = useDrag;
